import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { shortRegistrationRequest, shortRegistrationSuccess, shortRegistrationFailure } from '../reducers/login';
import { xapiRequest } from '../reducers/xapi';
import { API_LINK } from '../../constants';
import * as moment from 'moment';
const API = `${API_LINK}api/registerCoach`;

function* shortRegistrationFunctionAxios() {
 
  const state = yield select(fullState => fullState);
  const {
    email,
    password,
    firstname,
    lastname,
    programCode,
    AmLeader,
    identityNo,
    cell,
  } = state.form.registration.values;
  
  
  const response = yield call(() => {

    return axios({
      method: 'post',
      url: API,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      data: {
        firstname: firstname,
        lastname: lastname,
        email: email,
        password: password,
        projectCode: programCode,
        amLeader: 1,
        identityNo: identityNo,
        cell: cell,
      },
    });
  });
  console.log('REGISTER2',response);
  return response;
}

function* workerShortRegistrationSaga() {
  try {
    const response = yield call(shortRegistrationFunctionAxios);
    const responseFromLogin = response.data;

    if (response.status === 200) {
      yield put(shortRegistrationSuccess(responseFromLogin));
      yield put(xapiRequest({ xapiType: 'coachregistration' }));
    }

    if (response.status === 205) {
      yield put(shortRegistrationFailure('Email does not exist'));
    }
    if (response.status === 206) {
      yield put(shortRegistrationFailure(response.data));
    }
    if (response.status === 208) {
      yield put(shortRegistrationFailure(response.data));
    }
    if (response.status === 500) {
      yield put(shortRegistrationFailure(response.statusText));
    }
  } catch (error) {
    console.log('REGISTERERROR',error.message);
    yield put(shortRegistrationFailure(error.error));
  }
}

export function* watcherShortRegistrationSaga() {
  yield takeLatest(shortRegistrationRequest().type, workerShortRegistrationSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/post_shortRegistration.js